<div class="video-card">
  <!--LOADING MASK-->
  <ng-template [ngIf]="isLoading">
    <app-loading-page class="white-top-theme"></app-loading-page>
  </ng-template>
  <!--END LOADING MASK-->
  <ng-template [ngIf]="!isLoading">
    <app-tile-layout maxColumns="2">
      <li>
        <div *ngIf="featuredVideos && featuredVideos.length > 0">
          <!--FEATURED VIDEO HEADING-->
          <h2 class="text-align-left margin-top-large margin-bottom-large">Featured</h2>
          <!--END FEATURED VIDEO HEADING-->
          <!--NOTE: Slice or return the first featured video only-->
          <div
            *ngFor="
              let video of featuredVideos | slice : 0 : 1;
              let i = index;
              trackBy: trackByFeaturedVideoId
            ">
            <!--FEATURED VIDEO-->
            <app-video-container
              [title]="video.title"
              [embedUrl]="video.embed_url"
              (sendClick)="sendGoogleAnalytics('videos', 'click', video.slug)">
            </app-video-container>
            <!--END FEATURED VIDEO-->
            <!--FEATURED VIDEO DETAIL LINK-->
            <h3 class="margin-top-small" *ngIf="video.title">
              <a
                class="gen-neutral-black-link"
                href="javascript:void(0);"
                [routerLink]="['/video', video.slug]"
                (click)="sendGoogleAnalytics('videos', 'click', video.slug)"
                routerLinkActive="active">
                {{ video.title | decodeEntities }}
              </a>
            </h3>
            <!--END FEATURED VIDEO DETAIL LINK-->
            <!--FEATURED VIDEO DESCRIPTION-->
            <ng-container *ngIf="video.description">
              <p [innerHTML]="video.description"></p>
            </ng-container>
            <!--END FEATURED VIDEO DESCRIPTION-->
            <!-- <a *ngIf="video?.external_url" href="{{video.external_url}}" target="_blank" class="btn btn-primary">{{video.acf.external_link_cta}}</a> -->
          </div>
        </div>
      </li>
      <li>
        <div *ngIf="recommendedVideos.length > 0">
          <!--RECOMMENDED VIDEO HEADING-->
          <h2 class="text-align-left margin-top-large margin-bottom-large">Recommended</h2>
          <!--END RECOMMENDED VIDEO HEADING-->
          <!--NOTE: Slice or return the first 2 recommended video only-->

          <div
            *ngFor="
              let video of recommendedVideos | slice : 0 : 2;
              let i = index;
              trackBy: trackByRecommendedVideoId
            ">
            <!--RECOMMENDED VIDEO-->
            <app-video-container
              [title]="video.title"
              [embedUrl]="video.embed_url"
              (sendClick)="sendGoogleAnalytics('videos', 'click', video.slug)">
            </app-video-container>
            <!--END RECOMMENDED VIDEO-->
            <!--RECOMMENDED VIDEO DETAIL LINK-->
            <h3 class="margin-top-small margin-bottom-small" *ngIf="video.title">
              <a
                class="gen-neutral-black-link"
                href="javascript:void(0);"
                [routerLink]="['/video', video.slug]"
                routerLinkActive="active"
                (click)="sendGoogleAnalytics('videos', 'click', video.slug)">
                {{ video.title | decodeEntities }}
              </a>
            </h3>
            <!--RECOMMENDED VIDEO DETAIL LINK-->
          </div>
        </div>
      </li>
    </app-tile-layout>
  </ng-template>
</div>
